import { render, staticRenderFns } from "./InternationalShipmentDetails.vue?vue&type=template&id=302d44b1&scoped=true"
import script from "./InternationalShipmentDetails.vue?vue&type=script&lang=js"
export * from "./InternationalShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./InternationalShipmentDetails.vue?vue&type=style&index=0&id=302d44b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302d44b1",
  null
  
)

export default component.exports